import { InjectionToken } from '@angular/core';

export const DEFAULT_PENDO_API_KEY = 'b282d6fb-bff7-41b1-4041-8aaf036a6f4b';

/**
 * Override in an app's providers to point at a different Pendo subscription.
 */
export const PENDO_API_KEY = new InjectionToken<string>('PENDO_API_KEY', {
  providedIn: 'root',
  factory: () => DEFAULT_PENDO_API_KEY,
});
